import { createSvgIcon } from "@mui/material";

export const CollectionIcon = createSvgIcon(
  <svg
    id="collections-icon"
    data-name="Layer 2"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 15.35 10.01"
    fill="currentColor"
    strokeWidth={0}
  >
    <polygon
      points="0 0 0 10.01 7.61 5.75 15.35 10.01 15.35 0 0 0"
    />
  </svg>
);
